import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, Youtube, Award } from "lucide-react";
import { useCategories, useSettings, fileUrl } from "@/lib/api";
import { track } from "@/lib/seo";

const COMPANY = [["/about/legacy", "Our Legacy"], ["/about/team", "Leadership & Team"], ["/about/achievements", "Achievements"], ["/shipment-calculator", "Shipment Calculator"], ["/careers", "Careers"], ["/media", "Media"], ["/contact", "Contact"]];

export default function Footer() {
  const { data: cats = [] } = useCategories();
  const { data: s } = useSettings();
  const c = s?.contact || {};
  const soc = s?.social || {};
  const icons = [["linkedin", Linkedin], ["facebook", Facebook], ["instagram", Instagram], ["youtube", Youtube]];
  return (
    <footer data-testid="site-footer" className="bg-[var(--ivory-dark)] border-t border-[var(--stone)] mt-0">
      <div className="wrap grid sm:grid-cols-2 lg:grid-cols-4 gap-12 py-16">
        <div>
          <img src="/logo.png" alt="Tijiya Exports" className="h-12 mb-5" />
          <p className="text-sm text-[var(--graphite)] max-w-xs">Manufacturer and exporter of mild-steel fencing and construction hardware from Kolkata since 1987.</p>
          <p className="mt-5 inline-flex items-center gap-2 text-xs border border-[var(--brass)] text-[var(--brass)] px-3 py-2 rounded-sm"><Award size={14} /> Government of India Recognised Export House</p>
        </div>
        <div>
          <p className="eyebrow mb-5">Products</p>
          <ul className="space-y-2.5 text-sm">
            {cats.map((x) => <li key={x.slug}><Link to={`/products/${x.slug}`} className="hover:text-[var(--brass)] transition-colors">{x.name}</Link></li>)}
            <li><Link to="/products/all" className="hover:text-[var(--brass)] transition-colors">All Products A–Z</Link></li>
            <li>{s?.catalogue_url ? <a href={fileUrl(s.catalogue_url)} target="_blank" rel="noreferrer" onClick={() => track("catalogue_download")} className="link">Download Catalogue</a> : <Link to="/contact" className="link">Request Catalogue</Link>}</li>
          </ul>
        </div>
        <div>
          <p className="eyebrow mb-5">Company & Tools</p>
          <ul className="space-y-2.5 text-sm">{COMPANY.map(([to, l]) => <li key={to}><Link to={to} className="hover:text-[var(--brass)] transition-colors">{l}</Link></li>)}</ul>
        </div>
        <div className="text-sm space-y-3">
          <p className="eyebrow mb-5">Contact</p>
          <p className="text-[var(--graphite)]">{c.address}</p>
          <p>{(c.phones || []).map((p) => <a key={p} href={`tel:${p.replace(/\s/g, "")}`} className="block hover:text-[var(--brass)]">{p}</a>)}</p>
          <p>India <a href={`tel:${(c.mobile_india || "").replace(/\s/g, "")}`} className="hover:text-[var(--brass)]">{c.mobile_india}</a><br />USA <a href={`tel:${(c.mobile_usa || "").replace(/\s/g, "")}`} className="hover:text-[var(--brass)]">{c.mobile_usa}</a></p>
          <p><a href={`mailto:${c.email}`} className="link">{c.email}</a></p>
          <div className="flex gap-3 pt-2">
            {icons.map(([k, I]) => <a key={k} href={soc[k] || "#"} aria-label={k} data-testid={`social-${k}`} target={soc[k] ? "_blank" : undefined} rel="noreferrer" className="w-9 h-9 border border-[var(--stone)] flex items-center justify-center text-[var(--steel)] hover:text-[var(--brass)] hover:border-[var(--brass)] transition-colors"><I size={15} /></a>)}
          </div>
        </div>
      </div>
      <div className="border-t border-[var(--stone)]">
        <div className="wrap flex flex-col md:flex-row gap-3 justify-between py-6 text-xs text-[var(--graphite)]">
          <p>© {new Date().getFullYear()} Tijiya Exports Private Limited · <Link to="/privacy" className="hover:text-[var(--brass)]">Privacy Policy</Link> · <Link to="/terms" className="hover:text-[var(--brass)]">Terms</Link></p>
          <p className="serif text-sm italic">Est. 1987 as Tijiya Engineering</p>
        </div>
      </div>
    </footer>
  );
}
